import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 pb-4" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { mdiBullhornOutline } from '@mdi/js'

import { useChangelog } from '@/hooks/useChangelog'
import PATHS from '@/router/paths'
import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ChangelogEntry from '@/components/Changelog/ChangelogEntry.vue'

const RECENT_ENTRIES_LIMIT = 5


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangelogPanel',
  setup(__props) {

const router = useRouter()
const { entries, isPanelOpen, closePanel } = useChangelog()

const recentEntries = computed(() => entries.value.slice(0, RECENT_ENTRIES_LIMIT))

function onUpdateOpen(value: boolean) {
  if (!value) closePanel()
}

function goToChangelogPage() {
  closePanel()
  router.push(PATHS.CHANGELOG)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSidebar, {
    "model-value": _unref(isPanelOpen),
    title: "Novidades",
    description: "O que mudou nas últimas versões do Minha Escala.",
    icon: _unref(mdiBullhornOutline),
    "onUpdate:modelValue": onUpdateOpen
  }, {
    footer: _withCtx(() => [
      _createVNode(OutlineButton, {
        text: "Ver todas as novidades",
        width: "100%",
        height: "46px",
        "data-testid": "changelog-see-all-link",
        onClick: goToChangelogPage
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentEntries.value, (entry) => {
          return (_openBlock(), _createBlock(ChangelogEntry, {
            key: entry.version,
            entry: entry
          }, null, 8, ["entry"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["model-value", "icon"]))
}
}

})